import { ISong, ISongNote } from "../services/Entities";
import { Song } from "./Song";
import { IClock } from "./abstraction/IClock";
import { IPlayer } from "./abstraction/IPlayer";
import { ISynth } from "./abstraction/ISynth";

export class SongPlayer implements IPlayer {

    protected _state: "empty" | "play" | "pause" | "stop";
    protected _position: number;
    protected _curNoteIndex: number;
    protected _playAbort: AbortController;
    protected _playPromise: Promise<void>;

    constructor() {

        this._state = "empty";
        this.volume = 1;
        this.windowTime = 0;
        this.delay = -0.3;
    }

    async load(song: Song, synth: ISynth, clock: IClock) {

        this.song = song;
        this.synth = synth;
        this.clock = clock;

        this._position = 0;
        this._curNoteIndex = -1;
        this._state = "stop";
    }

    async playAsync() {

        if (this._state == "play" || this._state == "empty")
            return;

        await this.synth.openAsync();

        await this.synth.resetAsync();

        this.clock.setTime(this._position);

        this._state = "play";

        this._playPromise = new Promise<void>(async res => {

            while (true) {

                if (this._state != "play")
                    break;

                let note: ISongNote;

                while (this._curNoteIndex < this.song.length - 1) {
                    this._curNoteIndex++;
                    note = this.song.note(this._curNoteIndex);
                    if (note.time + this.delay > this.clock.getTime())
                        break;
                }

                this._position = this.clock.getTime();

                this.lastNote = note;

                const playTimeAbs = this.clock.getAbsTimeAt(note.time + this.delay);

                this.synth.playNote(note.note, this.volume * (note.velocity / 127), note.duration, playTimeAbs);

                const delta = (note.time + this.delay) - this.clock.getTime();

                if ((delta > this.windowTime || this.windowTime == 0)) {

                    if (!this._playAbort || this._playAbort.signal.aborted)
                        this._playAbort = new AbortController();

                    await this.clock.waitAsync(delta, this._playAbort.signal);
                }
                
            }

            console.log("play stop");

            res();
        });

        await this._playPromise;

        this._playPromise = undefined;
       
    }

    async setPositionAsync(posSec: number) {

        if (!this.song)
            return;

        console.log("Position req: ", posSec);

        let resumePlay = false;
        if (this._state == "play") {
            await this.pauseAsync();
            resumePlay = true;
        }

        const firstNote = Array.from(this.song.notes()).findIndex(a => a.time >= posSec);
        if (firstNote == -1)
            this._curNoteIndex = this.song.length - 1;
        else
            this._curNoteIndex = firstNote - 1;

        this._position = posSec;

        if (resumePlay) 
            this.playAsync();

        console.log("Position set: ", posSec);
    }

    async pauseAsync() {

        if (this._state != "play")
            return;

        this._state = "pause";

        await this.turnOffAsync();

        await this._playPromise;
    }

    async stopAsync() {

        if (this._state != "play" && this._state != "pause")
            return;

        console.log("Stop requested");

        this._state = "stop";

        await this.turnOffAsync();

        await this._playPromise;

        this.lastNote = undefined;

        this._position = 0;

        this._curNoteIndex = -1;
    }

    protected async turnOffAsync() {

        this._playAbort?.abort();

        this.synth.noteOff();

        for (let i = 0; i < 1; i += 0.1) {
            this.synth.noteOff(undefined, this.clock.getTime() + i);
        }
   

        await this.synth.closeAsync();
    }

    get position() {
        return this._position;
    }

    get state() {
        return this._state;
    }

    delay: number;

    lastNote: ISongNote;

    volume: number;

    song: Song;

    synth: ISynth;

    clock: IClock;

    windowTime: number;
}